import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { VDSManager } from "@vds/utilities";
import MyAccount from "../../components/myAccount/myAccount";
import ManageHeader from "../../components/header/ManageHeader";
import PlannedMaintenance from "../Login/PlannedMaintenance";
import { MainSection } from "../../constants/common/StyledGlobalConstants";

const Landing = React.memo(function Landing(props) {
  return (
    <>
      <VDSManager />
      <ManageHeader {...props} />
      <MainSection role="navigation" aria-label="Customer Portal">
        {props.displayPlannedMaintenance ? (
          <PlannedMaintenance />
        ) : (
          <>{props.activeTab === 1 && <MyAccount {...props} invoiceId={0} orderNumber={0} />}</>
        )}
      </MainSection>
    </>
  );
});

Landing.propTypes = {
  displayPlannedMaintenance: PropTypes.bool,
  activeTab: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    displayPlannedMaintenance: state.ACCOUNT.displayPlannedMaintenance,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Landing);
